import { httpClient } from "../../services/HttpClient";
import PriceTemplate from "../models/PriceTemplate";

export class PriceTemplateApi {

    static getUrl(projectUuid: string, endpoint: string = ''): string {
        return `/projects/${projectUuid}/pim/price-templates${endpoint}`;
    }

    static async findAll(projectUuid: string, request?: Record<string, any>): Promise<PriceTemplate[]> {
        const response = await httpClient.get(this.getUrl(projectUuid), request)

        return response.data.data.map((item: any) => new PriceTemplate(item));
    }

    static async find(projectUuid: string, priceTemplateUuid: string): Promise<PriceTemplate> {
        const response = await httpClient.get(this.getUrl(projectUuid, `/${priceTemplateUuid}`))

        return new PriceTemplate(response.data.data)
    }

    static async create(projectUuid: string, request: Record<string, any>): Promise<PriceTemplate> {
        const response = await httpClient.post(this.getUrl(projectUuid), request)

        return new PriceTemplate(response.data.data)
    }

    static async edit(projectUuid: string, request: Record<string, any>, priceTemplateUuid: string): Promise<PriceTemplate> {
        const response = await httpClient.patch(this.getUrl(projectUuid, `/${priceTemplateUuid}`), request)

        return new PriceTemplate(response.data.data)
    }

    static async remove(projectUuid: string, priceTemplateUuid: string): Promise<void> {
        return await httpClient.delete(this.getUrl(projectUuid, `/${priceTemplateUuid}`))
    }
}
